/* Kepler theme — AJAX cart drawer + variant selection.
   Uses Shopify's Cart AJAX API (/cart/add.js, /cart/change.js, /cart.js). */
(function () {
  'use strict';

  var money = function (cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang === 'de' ? 'de-DE' : 'en-IE', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2);
    }
  };

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var drawer = function () { return $('#cart-drawer'); };
  var overlay = function () { return $('#cart-overlay'); };

  function openCart() { overlay().classList.add('is-open'); drawer().classList.add('is-open'); }
  function closeCart() { overlay().classList.remove('is-open'); drawer().classList.remove('is-open'); }

  function render(cart) {
    var badge = $('#cart-count');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('is-visible', cart.item_count > 0);
    }
    var due = $('#cart-total');
    if (due) due.textContent = money(cart.total_price);

    var checkout = $('#cart-checkout');
    if (checkout) checkout.disabled = cart.item_count === 0;

    // keep every "how did you hear" select (drawer + /cart) on the stored answer
    var source = (cart.attributes && cart.attributes.Source) || '';
    Array.prototype.forEach.call(document.querySelectorAll('.js-cart-source'), function (sel) { sel.value = source; });

    var box = $('#cart-items');
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<p class="cart-empty">' + ((window.theme && window.theme.strings && window.theme.strings.cartEmpty) || 'Your cart is empty.') + '</p>';
      return;
    }
    box.innerHTML = cart.items.map(function (it) {
      var sub = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cart-line__meta">' + it.variant_title + '</p>' : '';
      return '' +
        '<div class="cart-line">' +
          '<div style="flex:1">' +
            '<p class="cart-line__title">' + it.product_title + '</p>' + sub +
            '<p class="cart-line__meta">' + money(it.final_price) + ' ' + ((window.theme && window.theme.strings && window.theme.strings.each) || 'each') + '</p>' +
          '</div>' +
          '<div class="qty">' +
            '<button data-change data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">–</button>' +
            '<span class="mono" style="width:1.5rem;text-align:center">' + it.quantity + '</span>' +
            '<button data-change data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
          '</div>' +
          '<span class="mono" style="width:4rem;text-align:right">' + money(it.final_line_price) + '</span>' +
        '</div>';
    }).join('');
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(openCart);
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    // Mobile menu: a tap anywhere outside it (or on one of its links) closes it.
    var menu = document.querySelector('.nav-mobile[open]');
    if (menu && (!t.closest('.nav-mobile') || t.closest('.nav-mobile__panel a'))) menu.removeAttribute('open');

    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }

    var quick = t.closest('[data-add]');
    if (quick) { e.preventDefault(); addToCart(quick.getAttribute('data-id'), 1); return; }

    var ch = t.closest('[data-change]');
    if (ch) { changeQty(ch.getAttribute('data-key'), parseInt(ch.getAttribute('data-qty'), 10)); return; }

    var checkout = t.closest('#cart-checkout');
    if (checkout) { window.location.href = '/checkout'; return; }
  });

  // Variant picker on the product page
  var picker = $('#variant-picker');
  if (picker) {
    var form = $('#product-form');
    var idInput = form ? $('input[name="id"]', form) : null;
    var priceOut = $('#product-price');

    picker.addEventListener('change', function (e) {
      var input = e.target;
      if (input.name !== 'variant') return;
      if (idInput) idInput.value = input.value;
      if (priceOut && input.getAttribute('data-price')) priceOut.textContent = money(parseInt(input.getAttribute('data-price'), 10));
      Array.prototype.forEach.call(picker.querySelectorAll('.variant'), function (l) { l.classList.remove('is-active'); });
      var label = input.closest('.variant');
      if (label) label.classList.add('is-active');
    });
  }

  // Product form -> AJAX add
  var pForm = $('#product-form');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idInput = $('input[name="id"]', pForm);
      var qtyInput = $('input[name="quantity"]', pForm);
      addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1);
    });
  }

  // "How did you hear about Kepler?" — store the answer the moment it is picked, so it reaches the
  // order whichever checkout button is used (cart attribute "Source").
  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('js-cart-source')) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { Source: e.target.value } })
    }).then(function (r) { if (!r.ok) throw new Error('cart update ' + r.status); return r.json(); }).then(render)
      .catch(function () { /* optional field: a failed save must not break the drawer */ });
  });

  if (overlay()) overlay().addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    var menu = document.querySelector('.nav-mobile[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  });

  refresh();
})();
